import { Ref, ref } from 'vue';
import { UserBlockContents } from '../../../../server/dto/generated/UserBlockContents';
import { BlocklyService } from '../../../biz/remote/BlocklyService';
import { SessionUser } from '../../../utils/SessionUser';

export class ClassMemberContainsLoader {
  /**
   * リアクティブ変数
   */
  public dispSize = ref(10);
  public ownedAllList: Ref<UserBlockContents[]> = ref([]);
  public fullList: Ref<UserBlockContents[]> = ref([]);
  public dispList: Ref<UserBlockContents[]> = ref([]);
  public filterText = ref('');
  public currentPage = ref(1);
  public newProjectId = ref('');

  /**
   * リストの読み込み
   */
  public load = async () => {
    // リストをロード
    const biz = new BlocklyService();
    const response = await biz.listForClass(
      SessionUser.instance.userId,
      SessionUser.instance.memberId
    );
    this.ownedAllList.value = response.data;
    console.log('ownedAllList', this.ownedAllList.value);
    this.fullList.value = this.ownedAllList.value.filter((item) =>
      item.title ? item.title.indexOf(this.filterText.value) > -1 : true
    );
  };

  /**
   * 新しく追加
   * @param project_id
   */
  addNew = async (project_id: string) => {
    this.newProjectId.value = project_id;
    await this.load();
  };

  /**
   * ページネイションの変更
   */
  pageChanged = (rowInPage: UserBlockContents[], currentPageNew: number) => {
    this.currentPage.value = currentPageNew + 1;
    this.dispList.value = rowInPage;
  };

  /**
   * フィルター
   */
  filter = async (text: string) => {
    this.filterText.value = text;
    await this.load();
  };
}
